"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmailEdit = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _RawEmailEditor = require("../raw-email-editor/RawEmailEditor");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _textField = _interopRequireDefault(require("../../preact-components/design-system-components/text-field"));

var _message = _interopRequireDefault(require("../../preact-components/design-system-components/message"));

var _userContext = require("../../server-middleware/userContext");

var _EmailVariablesDropdown = _interopRequireDefault(require("./EmailVariablesDropdown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailEdit = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailEdit, _Component);

  var _super = _createSuper(EmailEdit);

  function EmailEdit(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmailEdit);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cursor", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "codeMirror", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subjectSelectionStart", 0);
    _this.state = {
      emailSubject: props.subjectTranslation,
      emailBody: props.bodyTranslation,
      message: '',
      isDirty: false,
      messageType: undefined
    };
    _this.onSave = _this.onSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEmailBodyChange = _this.onEmailBodyChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEmailSubjectChange = _this.onEmailSubjectChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.insertVariableToSubject = _this.insertVariableToSubject.bind((0, _assertThisInitialized2.default)(_this));
    _this.insertVariableToBody = _this.insertVariableToBody.bind((0, _assertThisInitialized2.default)(_this));
    _this.sendTestEmail = _this.sendTestEmail.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUnload = _this.onUnload.bind((0, _assertThisInitialized2.default)(_this));
    _this.setCodeMirrorRef = _this.setCodeMirrorRef.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlurCodeMiror = _this.onBlurCodeMiror.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlurSubject = _this.onBlurSubject.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EmailEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        messageType: undefined
      });
      window.addEventListener('beforeunload', function (e) {
        return _this2.onUnload(e);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.state.isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var subjectResponse, bodyResponse;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });

                if (this.state.emailSubject !== this.props.subjectTranslation) {
                  subjectResponse = _axios.default.post('/email/system-emails/save', {
                    category: this.props.subjectModule,
                    message: this.props.subjectKey,
                    translation: this.state.emailSubject
                  });
                }

                if (this.state.emailBody !== this.props.bodyTranslation) {
                  bodyResponse = _axios.default.post('/email/system-emails/save', {
                    category: this.props.bodyModule,
                    message: this.props.bodyKey,
                    translation: this.state.emailBody
                  });
                }

                _context.prev = 3;
                _context.next = 6;
                return Promise.all([subjectResponse, bodyResponse]);

              case 6:
                this.setState({
                  messageType: 'success',
                  message: 'Email is saved successfully!',
                  isDirty: false
                }, function () {
                  window.setTimeout(function () {
                    return window.location.assign((0, _absoluteUrlRuntime.resolveUrl)('/email/system-emails'));
                  }, 3000);
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: 'Sorry, something went wrong, please try again.'
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function onSave() {
        return _onSave.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: "onEmailSubjectChange",
    value: function onEmailSubjectChange(value) {
      this.setState({
        emailSubject: value,
        isDirty: true
      });
    }
  }, {
    key: "onEmailBodyChange",
    value: function onEmailBodyChange(html) {
      if (this.state.emailBody !== html) {
        this.setState({
          emailBody: html,
          isDirty: true
        });
      }
    }
  }, {
    key: "insertVariableToSubject",
    value: function insertVariableToSubject(value) {
      var emailSubject = this.state.emailSubject;
      var newSubject = "".concat(emailSubject.slice(0, this.subjectSelectionStart)).concat(value).concat(emailSubject.slice(this.subjectSelectionStart));
      this.setState({
        emailSubject: newSubject,
        isDirty: true
      });
    }
  }, {
    key: "insertVariableToBody",
    value: function insertVariableToBody(value) {
      if (!this.cursor || !this.codeMirror) {
        this.setState({
          emailBody: "".concat(this.state.emailBody).concat(value),
          isDirty: true
        });
      } else {
        this.codeMirror.replaceRange(value, this.cursor);
      }
    }
  }, {
    key: "onBlurCodeMiror",
    value: function onBlurCodeMiror() {
      var _this$codeMirror;

      this.cursor = (_this$codeMirror = this.codeMirror) === null || _this$codeMirror === void 0 ? void 0 : _this$codeMirror.getCursor();
    }
  }, {
    key: "onBlurSubject",
    value: function onBlurSubject(e) {
      this.subjectSelectionStart = e.target.selectionStart || 0;
    }
  }, {
    key: "setCodeMirrorRef",
    value: function setCodeMirrorRef(codeMirror) {
      this.codeMirror = codeMirror;
    }
  }, {
    key: "sendTestEmail",
    value: function () {
      var _sendTestEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var userEmail;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userEmail = this.props.userEmail;
                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.post('/email/system-emails/send-test-email', {
                  title: this.state.emailSubject,
                  content: this.state.emailBody,
                  to: userEmail
                });

              case 4:
                this.setState({
                  messageType: 'success',
                  message: "A test email has been sent to your email address: ".concat(userEmail, ".")
                });
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  messageType: 'error',
                  message: 'Sorry, something went wrong, please try again.'
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));

      function sendTestEmail() {
        return _sendTestEmail.apply(this, arguments);
      }

      return sendTestEmail;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description,
          type = _this$props.type;
      var _this$state = this.state,
          emailSubject = _this$state.emailSubject,
          emailBody = _this$state.emailBody,
          messageType = _this$state.messageType,
          message = _this$state.message;
      return (0, _preact.h)("div", {
        className: "email-template-edit-page"
      }, (0, _preact.h)(_header.default, {
        title: "Edit '".concat(title, "' email"),
        hasBreadcrumb: true,
        breadcrumbText: "Back to System Emails",
        breadcrumbLink: "/email/system-emails",
        cancelCallback: function cancelCallback() {
          return window.location.assign((0, _absoluteUrlRuntime.resolveUrl)('/email/system-emails'));
        },
        saveCallback: this.onSave,
        customButtons: [{
          variant: 'primary',
          title: 'Send Test Email',
          action: this.sendTestEmail,
          newStyle: true,
          customClass: 'test-email-button'
        }]
      }), messageType && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: messageType,
        onDismiss: function onDismiss() {
          _this3.setState({
            messageType: undefined
          });
        },
        timer: 3000
      }, message), (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "email-template-description"
      }, (0, _preact.h)(_assets.default, {
        icon: "info",
        width: 20,
        height: 20,
        color: "#9599A2"
      }), " ", description, " "), (0, _preact.h)("div", {
        className: "email-template-subject-contianer"
      }, (0, _preact.h)(_EmailVariablesDropdown.default, {
        isSubject: true,
        emailType: type,
        onItemSelect: this.insertVariableToSubject
      }), (0, _preact.h)(_textField.default, {
        isControl: true,
        size: "fullWidth",
        name: "subject",
        label: "Subject",
        ariaLabel: "subject",
        id: "email-subject",
        onChange: this.onEmailSubjectChange,
        defaultValue: emailSubject,
        updateInputValue: emailSubject,
        onBlur: this.onBlurSubject
      })), (0, _preact.h)("div", {
        className: "email-template-editor-contianer"
      }, (0, _preact.h)(_EmailVariablesDropdown.default, {
        emailType: type,
        onItemSelect: this.insertVariableToBody
      }), (0, _preact.h)(_RawEmailEditor.RawEmailEditor, {
        content: emailBody,
        onContentChange: this.onEmailBodyChange,
        setCodeMirrorRef: this.setCodeMirrorRef,
        onBlur: this.onBlurCodeMiror
      }))));
    }
  }]);
  return EmailEdit;
}(_preact.Component);

exports.EmailEdit = EmailEdit;

var EmailEditWrapper = function EmailEditWrapper(props) {
  return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
    return (0, _preact.h)(EmailEdit, (0, _extends2.default)({
      userEmail: user.email
    }, props));
  });
};

var _default = EmailEditWrapper;
exports.default = _default;